import "./SortDesigns.scss";
import { useRef } from "react";
import { useOnClickOutside } from "usehooks-ts";
import { SortOption } from "../pages/Designs";
import { ArrowDownOutlined, ArrowUpOutlined, ClockCircleOutlined } from "@ant-design/icons";

export interface SortDesignsMenuProps {
  sortDesigns: (sort: SortOption) => void;
  closeMenu: () => void;
}

export default function SortDesignsMenu({
  sortDesigns,
  closeMenu
}: SortDesignsMenuProps) {
  const ref = useRef(null);

  const handleClickOutside = (ev: MouseEvent) => {
    closeMenu();
  }

  useOnClickOutside(ref, (ev) => handleClickOutside(ev as MouseEvent));

  function sortDesignsClick(option: SortOption) {
    sortDesigns(option);
    closeMenu();
  }

  return (
    <div className={"sort-designs-menu"} ref={ref}>
      <ul>
        <li onClick={() => sortDesignsClick(SortOption.EditedRecent)}>
          <ClockCircleOutlined/> Recently Edited
        </li>
        <li onClick={() => sortDesignsClick(SortOption.EditedRecentReverse)}>
          <ClockCircleOutlined/> Oldest Edited
        </li>
        <li onClick={() => sortDesignsClick(SortOption.NameAZ)}>
          <ArrowUpOutlined/> Alphabetical (A-Z)
        </li>
        <li onClick={() => sortDesignsClick(SortOption.NameZA)}>
          <ArrowDownOutlined/> Alphabetical (Z-A)
        </li>
      </ul>
    </div>
  );
}
